import { render } from "./ImageViewer.vue?vue&type=template&id=521228a6"
import script from "./ImageViewer.vue?vue&type=script&lang=js"
export * from "./ImageViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__